import { render, staticRenderFns } from "./SignatureListAccordion.vue?vue&type=template&id=5ffffd2f&lang=pug"
import script from "./SignatureListAccordion.vue?vue&type=script&lang=js"
export * from "./SignatureListAccordion.vue?vue&type=script&lang=js"
import style0 from "./SignatureListAccordion.vue?vue&type=style&index=0&id=5ffffd2f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports